import React, {useContext,useEffect } from "react";
import { AppTableColumnProps } from "./AppTableColumn";
import {AppTableContext} from "./AppTableProvider"
import {AppTableRow} from "./AppTableRow"

export interface AppTableBodyProps {
	columns?: AppTableColumnProps[];
	width?:number;
	afterLoad?:()=>void
}


export const AppTableBody = (props:AppTableBodyProps) =>{
	const {dataList,handleRowHover} = useContext(AppTableContext)

	const width = props.width === -1 ? '100%':`${props.width}px`
	const columns = props.columns

	useEffect(() => {
		props.afterLoad && props.afterLoad();
	  });

	return (
		<table cellPadding="0" cellSpacing="0" 
			style={{width}} 
			data-width = {props.width}
			onMouseOut={()=>handleRowHover(null)}  
		>
			<colgroup>
				{columns.map((column: AppTableColumnProps, index:number) => {
					if(column.width ===0){
						return <col key={`${index}_col`} />
					}else{
						return <col key={index} width={`${column.width}px`} />
					}
				})}
			</colgroup>
			<tbody>
				{dataList.map((data: any, index:number)=>{
					return <AppTableRow key={index} columns={columns} data={data} dataIndex={index}/>
				})}
			</tbody>
		</table>
		);

}



// WEBPACK FOOTER //
// ./src/qcc/AppTable/AppTableBody.tsx